import { css } from '@emotion/core'
import { Divider } from '@fs/zion-ui'
import React from 'react'

const dividerPadding = css`
  padding: 0px 16px;
`

export default function SectionDivider() {
  return (
    <div css={dividerPadding} data-testid="sectionDivider">
      <Divider />
    </div>
  )
}
